module.exports = __webpack_public_path__ + "img/d201304-2.e7cca423.jpg";